"use client";
import React, { useState } from "react";
import Icon from "@/components/ui/AppIcon";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Lütfen geçerli bir e-posta adresi girin.");
      return;
    }
    setError("");
    setSubmitted(true);
  };

  return (
    <section className="py-16 bg-muted">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">
        <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <Icon name="EnvelopeIcon" size={28} className="text-primary" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
          Konya&apos;dan Haberdar Olun
        </h2>
        <p className="text-muted-foreground text-sm mb-8">
          Yeni etkinlikler, fırsatlar ve kültürel içerikler için bültenimize abone olun.
        </p>

        {submitted ? (
          <div className="flex flex-col items-center gap-3 py-6">
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
              <Icon name="CheckCircleIcon" size={32} className="text-green-500" variant="solid" />
            </div>
            <p className="font-bold text-foreground">Teşekkürler!</p>
            <p className="text-sm text-muted-foreground">Bültenimize başarıyla abone oldunuz.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
            <div className="flex-1">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-posta adresiniz"
                className="w-full px-5 py-3.5 rounded-xl border border-border bg-white text-foreground placeholder-muted-foreground text-sm outline-none focus:border-primary transition-colors"
              />
              {error && <p className="text-xs text-red-500 mt-1.5 text-left">{error}</p>}
            </div>
            <button type="submit" className="btn-primary whitespace-nowrap">
              <Icon name="PaperAirplaneIcon" size={16} />
              Abone Ol
            </button>
          </form>
        )}

        <p className="text-xs text-muted-foreground mt-4">
          Abone olarak{" "}
          <a href="#" className="text-primary underline">KVKK aydınlatma metnini</a>{" "}
          kabul etmiş olursunuz.
        </p>
      </div>
    </section>
  );
}